/**
 * Mirrors src/html-components/component-compliance-prompt.html
 * Styles: codiii-kit.css (imported by parent or App)
 */
import React from 'react';

export default function CompliancePrompt({
  title = 'Run Compliance Scan',
  description = 'Ask questions or request specific compliance checks on your project documents.',
  placeholder = 'Type or speak your compliance prompt...',
  promptValue = '',
  onPromptChange,
  onRun,
  onVoiceToggle,
  isRecording = false,
  isRunning = false,
  runLabel = 'Run Compliance Scan',
  runLabelScanning = 'Scanning...',
  showLibrary = false,
  onToggleLibrary,
  savedPrompts = [],
  onSaveCurrent,
  onUsePrompt,
  onDeletePrompt,
  libraryEmptyText = 'No saved prompts yet. Save your current prompt to reuse it.',
  showHeader = true,
  showRunButton = true,
  inputDisabled = false,
  className = '',
}) {
  return (
    <div className={`compliance-prompt${className ? ` ${className}` : ''}`}>
      {showHeader ? (
        <div className="prompt-header">
          <h3 className="prompt-title">{title}</h3>
          <p className="prompt-description">{description}</p>
        </div>
      ) : null}
      <div className="prompt-input-wrapper">
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            className={`prompt-library-btn ${showLibrary ? 'active' : ''}`}
            title="Prompt Library"
            onClick={onToggleLibrary}
            aria-expanded={showLibrary}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z"/>
            </svg>
          </button>
          <div className={`prompt-library-dropdown ${showLibrary ? 'active' : ''}`} style={{ display: showLibrary ? 'flex' : 'none', flexDirection: 'column', minWidth: 280 }}>
            <div className="prompt-library-header">
              <h4 className="prompt-library-title">Saved Prompts</h4>
              <button type="button" className="prompt-library-add-btn" onClick={onSaveCurrent}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                </svg>
                Save Current
              </button>
            </div>
            <div className="prompt-library-list">
              {savedPrompts.length === 0 && (
                <div className="prompt-library-empty">{libraryEmptyText}</div>
              )}
              {savedPrompts.map((sp) => (
                <div key={sp.id} className="prompt-library-item">
                  <span className="prompt-library-item-text">{sp.text}</span>
                  <div className="prompt-library-item-actions">
                    <button type="button" className="prompt-library-item-use-btn" onClick={() => onUsePrompt && onUsePrompt(sp)}>Use</button>
                    <button type="button" className="prompt-library-item-delete-btn" onClick={() => onDeletePrompt && onDeletePrompt(sp.id)} aria-label="Delete">×</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="prompt-input-container">
          <input
            type="text"
            className="prompt-input"
            placeholder={placeholder}
            value={promptValue}
            disabled={inputDisabled}
            onChange={(e) => onPromptChange && onPromptChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !inputDisabled) {
                e.preventDefault();
                onRun && onRun();
              }
            }}
            aria-label="Compliance prompt"
          />
          <button
            type="button"
            className={`prompt-voice-btn ${isRecording ? 'active' : ''}`}
            onClick={onVoiceToggle}
            title={isRecording ? 'Stop voice' : 'Voice Recording'}
            aria-label={isRecording ? 'Stop voice' : 'Start voice'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
            </svg>
          </button>
        </div>
        {showRunButton ? (
          <button type="button" className="prompt-run-btn" onClick={onRun} disabled={isRunning}>
            {isRunning ? runLabelScanning : runLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
